import React from 'react';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import TabelaVagas from './components/TabelaVagas'
import { useDispatch, useSelector } from 'react-redux';
import { getOpportunityCompany } from '../../serviceAPI/opportunity/getOpportunityCompany';

const useStyles = makeStyles((theme) => ({
  main: {
    padding: theme.spacing(3),
  }
}));

function VerCandidatos() {
  const classes = useStyles();

  const vagas = useSelector(state => state.opportunity.opportunities)
  const dispatch = useDispatch();

  React.useEffect(() => {
    getOpportunityCompany(dispatch);
  }, []);

  return (
    <Container className={classes.main}>
      <TabelaVagas vagas={vagas} />
    </Container >
  )
}

export default VerCandidatos;